import { create } from 'zustand'

/** A panel's current one-line insight, published for the Ask AI rail to aggregate
 *  ("what your panels are saying"). Keyed by panelId so remounts/updates replace. */
export interface PanelInsight {
  panelId: string
  componentType: string
  text: string
  data?: Record<string, unknown>
}

interface PanelInsightsState {
  insights: Record<string, PanelInsight>
  setInsight: (insight: PanelInsight) => void
  clearInsight: (panelId: string) => void
}

export const usePanelInsightsStore = create<PanelInsightsState>((set) => ({
  insights: {},
  setInsight: (insight) =>
    set((s) => ({ insights: { ...s.insights, [insight.panelId]: insight } })),
  clearInsight: (panelId) =>
    set((s) => {
      if (!(panelId in s.insights)) return s
      const next = { ...s.insights }
      delete next[panelId]
      return { insights: next }
    }),
}))
